import _ from 'lodash';
import React, { useContext } from 'react';
import { DetailedSwitch } from 'src/presentation/components/forms/DetailedSwitch';
import { ExternalActionConfig } from 'src/presentation/components/pages/integrations/actionConfigurations';
import FormContext from 'src/presentation/contexts/FormContext';

interface CustomActionSettingsProps {
  actions: ExternalActionConfig[];
  integrationLabel: string;
}

export const CustomActionSettings: React.FC<CustomActionSettingsProps> = ({ actions, integrationLabel }) => {
  const { workingState } = useContext(FormContext);

  const createSwitchHeading = (actionHeading: string, attr: string) => {
    return (
      <>
        {actionHeading} is turned {_.get(workingState, attr) ? 'on' : 'off'}
      </>
    );
  };

  return (
    <div data-aid="custom-actions-settings-section">
      {actions.length > 0 ? <h4>Available {integrationLabel} Actions</h4> : null}

      {_.map(actions, action => (
        <DetailedSwitch
          attr={`actionSettings.customSettings.${action.attrKey}.enabled`}
          conditionalText={false}
          data-aid={`action-settings-${action.attrKey}`}
          key={`switch-key-${action.attrKey}`}
          switchHeading={createSwitchHeading(
            action.actionHeading,
            `actionSettings.customSettings.${action.attrKey}.enabled`
          )}
          subtext={action.actionSubtext}
        />
      ))}
    </div>
  );
};
